import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

import { WizardButtonsWrapper } from "app/components/campaigns/campaigns-wizard/CampaignsStyledComponents";
import { StyledTabs } from "app/pages/sales-intelligence/sub-modules/account-overview/shared/components/StickyTabs/styles";

const BREADCRUMBS_HEIGHT = 60;

export const StyledJobEditorWrapper = styled(Stack)`
    justify-content: space-between;
    min-height: calc(100vh - ${BREADCRUMBS_HEIGHT}px);
`;

export const StyledJobEditorContent = styled(Stack)`
    gap: 24px;
    width: 100%;
    max-width: 1054px;
    height: calc(100vh - ${BREADCRUMBS_HEIGHT + 108}px);
    margin: 32px auto 0;

    overflow: hidden;
`;

export const StyledJobEditorScrolledContainer = styled.div`
    overflow: auto;
    height: 100%;
    background-color: ${colorsPalettes.carbon[0]};

    ${StyledTabs} {
        padding: 0;
    }
`;

export const StyledJobEditorButtonsWrapper = styled(WizardButtonsWrapper)`
    max-width: 1054px;
    margin: 0 auto;
`;

export const StyledCrmEnrichmentJobEditorDeleteWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    margin-top: -9px;

    button {
        border: 1px solid ${colorsPalettes.red[400]};

        &:hover {
            border-color: ${colorsPalettes.red[500]};
        }

        &:active {
            border-color: ${colorsPalettes.red.s100};
        }
    }
`;
